module.exports = __webpack_public_path__ + "static/media/app-available.b9245fe0.png";